import { useTranslation } from "react-i18next";
import { APP_BUILD, APP_VERSION, CHANGELOG } from "../lib/changelog.ts";

/** What changed, release by release; the running one is marked. */
export function ChangelogPage() {
  const { t, i18n } = useTranslation();
  const date = (d: string) => new Date(`${d}T12:00:00Z`).toLocaleDateString(i18n.language, { day: "numeric", month: "long", year: "numeric" });
  return (
    <div className="page page-narrow changelog">
      <div>
        <h1 className="page-title">{t("changelog.title")}</h1>
        <p className="muted">
          {t("changelog.running", { version: APP_VERSION })}
          {APP_BUILD && ` · ${t("changelog.build", { build: APP_BUILD })}`}
        </p>
      </div>
      <ol className="releases">
        {CHANGELOG.map((r) => (
          <li key={r.version} className={`card release${r.version === APP_VERSION ? " is-current" : ""}`}>
            <div className="release-head">
              <span className="release-version">v{r.version}</span>
              <h2 className="panel-title">{r.title}</h2>
              <span className="muted small">{date(r.date)}</span>
              {r.version === APP_VERSION && <span className="release-tag">{t("changelog.current")}</span>}
            </div>
            <ul>
              {r.changes.map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </div>
  );
}
